export const DRAG_MODE = { MOVE: 'move', RESIZE: 'resize' }
